import React from 'react';
import {
  Container,
  Typography,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Stack,
  Box,
  LinearProgress,
  Tooltip,
  IconButton
} from '@mui/material';
import UserAvatar from '../../Avatar/UserAvatar';
import { EmojiEvents, Delete as DeleteIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function TeacherStudentsTab({ students, loading, onDeleteClick }) {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl">
      <Typography component="h2" variant="h6" sx={{ mb: 3 }}>
        学生列表
      </Typography>

      {loading ? (
        <LinearProgress />
      ) : (
        <Card variant="outlined">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>学生</strong></TableCell>
                  <TableCell><strong>手机号</strong></TableCell>
                  <TableCell align="center"><strong>已尝试</strong></TableCell>
                  <TableCell align="center"><strong>已通过</strong></TableCell>
                  <TableCell align="center"><strong>平均分</strong></TableCell>
                  <TableCell><strong>各专题进度</strong></TableCell>
                  <TableCell align="center"><strong>操作</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {students.map((student) => (
                  <TableRow
                    key={student.id}
                    hover
                    sx={{ cursor: 'pointer' }}
                    onClick={() => navigate(`/student/${student.id}`)}
                  >
                    <TableCell>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <UserAvatar 
                          user={student}
                          size={32}
                        />
                        <Typography fontWeight="medium">{student.name}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>{student.phoneNumber}</TableCell>
                    <TableCell align="center">
                      <Chip label={student.stats.totalAttempted} size="small" variant="outlined" />
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={student.stats.totalPassed}
                        color="success"
                        size="small"
                        icon={<EmojiEvents />}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Typography fontWeight="bold" color="primary.main">
                        {student.stats.overallAverage}分
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" gap={0.5} flexWrap="wrap">
                        {Object.entries(student.stats.byCategory).map(([cat, stats]) => (
                          <Chip
                            key={cat}
                            label={`${cat}: ${stats.passed}/${stats.attempted}`}
                            size="small"
                            color={stats.passed === stats.attempted && stats.attempted > 0 ? 'success' : 'default'}
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="删除学生">
                        <IconButton
                          color="error"
                          size="small"
                          onClick={(e) => onDeleteClick(e, student)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {students.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <Typography color="text.secondary" py={3}>暂无学生数据</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
    </Container>
  );
}

export default TeacherStudentsTab;
